<template>
    <div :class="['modal', 'fade', 'modal-upload-default', active ? 'show' : '']"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        :style="active ? 'display: block;' : ''">
        <div class="modal-dialog" role="document" style="z-index: 1041 !important;">
            <div class="modal-content">
                <div class="modal-header">
                    <button v-on:click="close"
                        type="button" class="modal-close" aria-label="Close">
                        <i class="font-icon-close-2"></i>
                    </button>
                    <h4 class="modal-title">Upload File</h4>
                </div>
                <div class="modal-upload">
                    <div class="modal-upload-cont">
                        <div class="tab-content">
                            <div role="tabpanel" class="tab-pane active" id="tab-upload">
                                <div class="modal-upload-body scrollable-block" style="height: inherit;">
                                    <div class="uploading-container">
                                        <drop
                                            v-on:dragleave="onDragLeave"
                                            v-on:dragover="onDragOver"
                                            v-on:drop="onFileDropped">
                                            <div :class="['drop-zone', isDragging ? 'dragover' : '']" style="width: initial;">
                                                <i class="font-icon font-icon-cloud-upload-2"></i>
                                                <div class="drop-zone-caption">Drag file to upload</div>
                                                <span class="btn btn-rounded btn-file btn-sm">
                                                    <span>Choose file</span>
                                                    <input type="file"
                                                        v-on:change="onFileSelected"
                                                        style="left: -330px; top: -130px;"
                                                        multiple />
                                                </span>
                                                <div class="mt-3">
                                                    <hr class="m-auto" style="width: 75%;">
                                                    <label class="drop-zone-caption mt-2">Or input image url here</label>
                                                    <div class="input-group w-50 m-auto">
                                                        <input v-model="imageUrl" class="form-control" type="url"/>
                                                        <div class="input-group-append">
                                                            <button type="button"
                                                                v-on:click="fetchImage"
                                                                :disabled="!imageUrl"
                                                                class="btn btn-outline-secondary"
                                                                >Upload</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </input>
                                        </drop><!--.uploading-container-left-->
                                        <!-- <div class="uploading-container"> -->
                                            <div class="uploading-container-in">
                                                <ul class="uploading-list list-unstyled mb-0">
                                                    <li v-for="file in files" class="uploading-list-item">
                                                        <div class="uploading-list-item-wrapper">
                                                            <div class="uploading-list-item-name">
                                                                <i class="font-icon font-icon-cam-photo"></i>
                                                                {{file.name}}
                                                            </div>
                                                            <div
                                                                class="uploading-list-item-size">{{getFileSize(file.size)}}</div>
                                                            <button v-on:click="removeFile(file.id)" type="button" class="uploading-list-item-close">
                                                                <i class="font-icon-close-2"></i>
                                                            </button>
                                                        </div>
                                                        <div class="progress">
                                                            <span class="progress-bar" :style="'width: ' + uploading[file.name] + '%;'"></span>
                                                        </div>
                                                        <div class="uploading-list-item-progress">{{uploading[file.name]}}%</div>
                                                        <div v-if="uploading[file.name] == 100" class="uploading-list-item-speed">Done</div>
                                                    </li>
                                                    <li v-for="file in rejectedFiles" class="uploading-list-item" style="color: red;">
                                                        <div class="uploading-list-item-wrapper">
                                                            <div class="uploading-list-item-name">
                                                                <i class="font-icon font-icon-cam-photo"></i>
                                                                {{file.name}}
                                                            </div>
                                                            <div
                                                                class="uploading-list-item-size">Invalid extension</div>
                                                            <button v-on:click="removeFile(file.id)" type="button" class="uploading-list-item-close">
                                                                <i class="font-icon-close-2"></i>
                                                            </button>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div><!--.uploading-container-right-->
                                    <!-- </div> -->
                                    <!--.uploading-container-->
                                </div><!--.modal-upload-body-->
                                <div class="modal-upload-bottom">
                                    <button v-on:click="close" type="button" class="btn btn-rounded btn-secondary btn-sm">Close</button>
                                    <!-- <button type="button" class="btn btn-rounded">Done</button> -->
                                </div><!--.modal-upload-bottom-->
                            </div><!--.tab-pane-->
                        </div><!--.tab-content-->
                    </div><!--.modal-upload-cont-->
                </div>
            </div>
        </div>
        <div v-if="active" class="modal-backdrop fade show"></div>
    </div>
</template>
<script>
import Vue from 'vue';
import filesize from 'filesize';
import mime from 'mime-types';

import { Drop } from 'vue-drag-drop';

export default {
    data() {
        return {
            imageUrl: '',
            loading: false,
            isDragging: false,
            files: [],
            rejectedFiles: [],
            fileList: [],
            uploading: {},
            error: {},
        }
    },

    props: ['active', 'extensions', 'uploadFile'],

    components: {
        Drop,
    },

    watch: {
        active() {
            this.files = [];
            this.rejectedFiles = [];
            this.uploading = {};
        }
    },

    mounted() {
        console.log('Component mounted.')
    },

    methods: {
        close() {
            this.$emit('modal-close');
        },

        onFileDropped(_, e) {
            e.preventDefault();
            this.isDragging = false;
            const files = this.getFileArray(e.dataTransfer.files);
            this.files = this.files.concat(files);
            this.uploadFiles(files);
        },

        onFileSelected(e) {
            e.preventDefault();
            const files = this.getFileArray(e.target.files);
            this.files = this.files.concat(files);
            this.uploadFiles(files);
        },

        onDragOver(_, e) {
            e.preventDefault();
            this.isDragging = true;
        },

        onDragLeave(_, e) {
            e.preventDefault();
            this.isDragging = false;
        },

        getFileArray(fileList) {
            const length = fileList.length;
            const fileArray = [];
            const timestamp = Date.now();
            for (let i = 0; i < length; i++) {
                const file = fileList.item(i);
                file.id = `${timestamp}.${i}`;
                fileArray.push(fileList.item(i));
            }
            return fileArray;
        },

        getFileSize(val) {
            return filesize(val);
        },

        removeFile(id) {
            this.files = this.files.filter(file => file.id != id);
            this.rejectedFiles = this.rejectedFiles.filter(file => file.id != id);
        },

        uploadFiles(files, upload = true) {
            this.files = files.filter(file => this.extensions.indexOf(mime.extension(file.type)) >= 0);
            this.rejectedFiles = files.filter(file => this.extensions.indexOf(mime.extension(file.type)) < 0);

            const uploadHandler = upload ?
                (file => this.uploadFile({ file }, true)) :
                (file => this.uploadFile(file, false));

            Promise.all(this.files.map(file => {
                this.uploading[file.name] = 0;
                const interval = setInterval(() => {
                    this.uploading = {
                        ...this.uploading,
                        [file.name]: _.min([this.uploading[file.name] + 1, 75]),
                    };
                }, 100);

                return uploadHandler(file)
                    .then(() => {
                        this.uploading = { ...this.uploading, [file.name]: 100 };
                    })
                    .catch((e) => {
                        this.rejectedFiles = this.rejectedFiles.concat(file);
                    })
                    .finally(() => {
                        clearInterval(interval);
                    })
            }))
        },

        fetchImage() {
            const file = {
                name: this.imageUrl,
                uri: this.imageUrl,
                type: 'image/jpeg',
                size: 0,
            }

            this.files = [file];
            return this.uploadFiles([file], false);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/UploadModalComponent.vue